import {apiMethods} from "./Request";
import {Config} from "./Global";
import history from './History';

const USER_TOKEN_KEY = 'user_token';

export function login(email, password) {
    const API_URL = Config['api']['auth']['login'];
    const requestData = JSON.stringify({email, password});
    return apiMethods.post(API_URL, requestData)
}


export function logout() {
    clearUserToken();
    history.push('/');
}

export function requireAuth(nextState, replace) {
    if (!isLoggedIn()) {
        replace({pathname: '/'});
    }
}

export function getUserToken() {
    return localStorage.getItem(USER_TOKEN_KEY);
}

export function clearUserToken() {
    localStorage.removeItem(USER_TOKEN_KEY);
}

export function setUserToken(token) {
    localStorage.setItem(USER_TOKEN_KEY, token);
}

export function isLoggedIn() {
    const userToken = getUserToken();
    return !!userToken;
}



// WEBPACK FOOTER //
// ./src/controller/AuthService.jsx